import {apiGet} from "../../shared/api/client";

const cleanParams = (filters) =>
    Object.fromEntries(Object.entries(filters || {}).filter(([, value]) => value !== "" && value !== null && value !== undefined));

export const loadEndpoint = async (url, filters = {}) => apiGet(url, {params: cleanParams(filters)});

export const loadOptionalEndpoints = async (requests) => {
    const entries = await Promise.allSettled(requests.map((request) => loadEndpoint(request.url, request.filters)));
    return entries.reduce((acc, result, index) => {
        acc[requests[index].key] = result.status === "fulfilled" ? {ok: true, data: result.value} : {ok: false, error: result.reason};
        return acc;
    }, {});
};
